import { proxyCustomElement, HTMLElement, h, Host } from '@stencil/core/internal/client';

const mapyMapmenuMapsetOptionsCss = "mapy-mapmenu-mapset-options{display:flex;gap:8px;flex-direction:column;align-items:flex-start;border-radius:8px;background:rgba(1, 30, 57, 0.04);padding:6px}mapy-mapmenu-mapset-options>mapy-mapmenu-mapset-options{align-self:stretch;margin:0}mapy-mapmenu-mapset-options mapy-mapmenu-mapset-option{padding:0 0 0 8px}";

const MapyMapmenuMapsetOptions$1 = /*@__PURE__*/ proxyCustomElement(class MapyMapmenuMapsetOptions extends HTMLElement {
  constructor() {
    super();
    this.__registerHost();
  }
  render() {
    return h(Host, null, h("slot", null));
  }
  static get style() { return mapyMapmenuMapsetOptionsCss; }
}, [4, "mapy-mapmenu-mapset-options"]);
function defineCustomElement$1() {
  if (typeof customElements === "undefined") {
    return;
  }
  const components = ["mapy-mapmenu-mapset-options"];
  components.forEach(tagName => { switch (tagName) {
    case "mapy-mapmenu-mapset-options":
      if (!customElements.get(tagName)) {
        customElements.define(tagName, MapyMapmenuMapsetOptions$1);
      }
      break;
  } });
}
defineCustomElement$1();

const MapyMapmenuMapsetOptions = MapyMapmenuMapsetOptions$1;
const defineCustomElement = defineCustomElement$1;

export { MapyMapmenuMapsetOptions, defineCustomElement };

//# sourceMappingURL=mapy-mapmenu-mapset-options.js.map